<div class="relative w-full dialog-container" style="font-family: 'Open Sans';">
  <div (click)="cancel()" class="absolute top-0 right-0 cursor-pointer">
    <svg width="16" viewBox="0 0 12 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.17188 7.5L9.51562 9.86719C9.82031 10.1484 9.82031 10.6172 9.51562 10.8984L9 11.4141C8.71875 11.7188 8.25 11.7188 7.96875 11.4141L5.625 9.07031L3.25781 11.4141C2.97656 11.7188 2.50781 11.7188 2.22656 11.4141L1.71094 10.8984C1.40625 10.6172 1.40625 10.1484 1.71094 9.86719L4.05469 7.5L1.71094 5.15625C1.40625 4.875 1.40625 4.40625 1.71094 4.125L2.22656 3.60938C2.50781 3.30469 2.97656 3.30469 3.25781 3.60938L5.625 5.95312L7.96875 3.60938C8.25 3.30469 8.71875 3.30469 9 3.60938L9.51562 4.125C9.82031 4.40625 9.82031 4.875 9.51562 5.15625L7.17188 7.5Z"
        fill="#181A18" />
    </svg>
  </div>

  <div class="text-lg font-semibold mb-6">Comments</div>
  <div id="commentsSection" class="flex flex-col w-full">
    <div class="flex flex-col">
      <span class="font-semibold text-sm mb-2">Cause</span>
      <mat-form-field appearance="outline" class="text-sm">
        <textarea matInput placeholder="Cause" (change)="setSaveCommentsFlag(data.task)" name="cause"
          [(ngModel)]="data.task.cause" maxlength="5000"></textarea>
      </mat-form-field>
    </div>

    <div class="flex flex-col">
      <span class="font-semibold text-sm mb-2">Correction</span>
      <mat-form-field appearance="outline" class="text-sm">
        <textarea matInput placeholder="Correction" (change)="setSaveCommentsFlag(data.task)" name="correction"
          [(ngModel)]="data.task.correction" maxlength="5000"></textarea>
      </mat-form-field>
    </div>

    <div class="flex flex-col">
      <span class="font-semibold text-sm mb-2">Notes</span>
      <mat-form-field appearance="outline" class="text-sm">
        <textarea matInput placeholder="Note" (change)="setSaveCommentsFlag(data.task)" name="note"
          [(ngModel)]="data.task.note" maxlength="5000"></textarea>
      </mat-form-field>
    </div>
  </div>

  <div class="flex flex-row place-content-end items-center mt-4">
    <span (click)="cancel()" class="flex place-items-center place-content-center py-2 px-5 rounded-md cursor-pointer"
      [ngStyle]="{ border: '1px solid #515251'}">Cancel</span>
    <button (click)="save(data.task)" id="saveButton"
      class="flex place-items-center place-content-center py-2 px-5 rounded-md ml-3 cursor-pointer"
      [ngStyle]="{ background: 'rgba(0, 84, 166, 1)'}" type="submit">
      <span class="text-white font-medium text-sm">Save</span>
    </button>
  </div>
</div>